module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Pixels.122a9e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Pixels.jpg
// module id = 9Jmw
// module chunks = 0